export enum DashboardWorkflowStepState {
    All = 1,
    CompletedSteps,
    StartedSteps,
}
